// Hero Slider Accessibility Management
// This script manages focus and screen reader visibility for carousel slides

document.addEventListener('DOMContentLoaded', function() {
  // Find all hero sliders on the page
  const heroSliders = document.querySelectorAll('[data-component="swiper"]');
  
  heroSliders.forEach(sliderElement => {
    // Wait for Swiper to initialize
    const observer = new MutationObserver((mutations, obs) => {
      if (sliderElement.swiper) {
        setupSliderAccessibility(sliderElement.swiper);
        obs.disconnect();
      }
    });
    
    observer.observe(sliderElement, {
      childList: true,
      subtree: true
    });
    
    // Fallback: try to setup immediately if swiper already exists
    if (sliderElement.swiper) {
      setupSliderAccessibility(sliderElement.swiper);
    }
  });
});

function setupSliderAccessibility(swiper) {
  // Initial setup - hide all slides except active
  updateSlideAccessibility(swiper);
  
  // Update accessibility when slide changes
  swiper.on('slideChange', function() {
    updateSlideAccessibility(swiper);
  });
  
  // Update accessibility when swiper is updated/resized
  swiper.on('update', function() {
    updateSlideAccessibility(swiper);
  });
}

function updateSlideAccessibility(swiper) {
  const slides = swiper.slides;
  const activeIndex = swiper.activeIndex;
  
  slides.forEach((slide, index) => {
    const isActive = index === activeIndex;
    
    if (isActive) {
      // Make active slide visible and focusable
      slide.removeAttribute('aria-hidden');
      enableFocusableElements(slide);
    } else {
      // Hide inactive slides from screen readers and keyboard
      slide.setAttribute('aria-hidden', 'true');
      disableFocusableElements(slide);
    }
  });
}

function disableFocusableElements(container) {
  // Find all focusable elements
  const focusableElements = container.querySelectorAll(
    'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
  );
  
  focusableElements.forEach(element => {
    // Store original tabindex if it exists
    if (element.hasAttribute('tabindex')) {
      element.setAttribute('data-original-tabindex', element.getAttribute('tabindex'));
    } else {
      element.setAttribute('data-original-tabindex', '0');
    }
    
    // Disable focus
    element.setAttribute('tabindex', '-1');
  });
}

function enableFocusableElements(container) {
  // Find all elements that were disabled
  const disabledElements = container.querySelectorAll('[data-original-tabindex]');
  
  disabledElements.forEach(element => {
    const originalTabindex = element.getAttribute('data-original-tabindex');
    
    if (originalTabindex === '0') {
      // Remove tabindex to restore natural tab order
      element.removeAttribute('tabindex');
    } else {
      // Restore original tabindex value
      element.setAttribute('tabindex', originalTabindex);
    }
    
    // Clean up data attribute
    element.removeAttribute('data-original-tabindex');
  });
}

// Handle keyboard navigation
document.addEventListener('keydown', function(event) {
  // Only handle if focus is within a hero slider
  const slider = event.target.closest('[data-component="swiper"]');
  if (!slider || !slider.swiper) return;
  
  const swiper = slider.swiper;
  
  // Handle arrow key navigation
  if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
    // Only if focus is on the slider container or pagination
    const isPaginationFocus = event.target.closest('.swiper-pagination');
    const isSliderFocus = event.target === slider;
    
    if (isPaginationFocus || isSliderFocus) {
      event.preventDefault();
      
      if (event.key === 'ArrowLeft') {
        swiper.slidePrev();
      } else {
        swiper.slideNext();
      }
    }
  }
});

// Announce slide changes to screen readers
function announceSlideChange(swiper) {
  const activeSlide = swiper.slides[swiper.activeIndex];
  const slideLabel = activeSlide.getAttribute('aria-label');
  
  // Create or update live region for announcements
  let liveRegion = document.getElementById('slider-announcements');
  if (!liveRegion) {
    liveRegion = document.createElement('div');
    liveRegion.id = 'slider-announcements';
    liveRegion.setAttribute('aria-live', 'polite');
    liveRegion.setAttribute('aria-atomic', 'true');
    liveRegion.style.position = 'absolute';
    liveRegion.style.left = '-10000px';
    liveRegion.style.width = '1px';
    liveRegion.style.height = '1px';
    liveRegion.style.overflow = 'hidden';
    document.body.appendChild(liveRegion);
  }
  
  // Announce the slide change
  liveRegion.textContent = slideLabel || `Slide ${swiper.activeIndex + 1} of ${swiper.slides.length}`;
}